module.exports = __webpack_public_path__ + "fonts/InstagramSansCondensed-Regular.3bce8022.eot";